import RecipeComposerModal from "./RecipeComposerModal";

export default function EditRecipePopup({ isOpen, recipeId, onClose, onSaved }) {
  return (
    <RecipeComposerModal
      isOpen={isOpen}
      mode="edit"
      recipeId={recipeId}
      onClose={onClose}
      onSaved={onSaved}
    />
  );
}
